//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import StateComponent from '@/components/StateComponent.vue';
import { firebaseConfig, GA_EVENTS } from '@/js/constants';
export default {
  name: 'Somos1Report',
  components: {
    StateComponent: StateComponent
  },
  data: function data() {
    return {
      dashboardUrl: '',
      showDashboard: false,
      report: null,
      breadcrumb: {
        level_1: {
          title: '',
          url: '#'
        },
        level_2: {
          title: '',
          url: '#'
        },
        level_3: {
          title: '',
          url: '#'
        }
      },
      maintenance: true,
      isAnimated: 0
    };
  },
  created: function created() {
    if (this.$route.params.no_require_agreement || userInfo.somos1_agreement) {
      this.getReport(this.$route.params.report_id);
    } else {
      this.$router.push({
        name: 'somos1_list'
      });
    }
  },
  methods: {
    getReport: function getReport(reportId) {
      var _this = this;
      Somos1Service.getSomos1Report(reportId).then(function (response) {
        _this.report = response.data;
        if (response.data.section === 'Somos1') {
          _this.breadcrumb.level_1.title = _this.translate('menu.customer.somos1_reports');
          _this.breadcrumb.level_1.url = '/#/customer_insights/somos1';
          if (response.data && response.data.tags && response.data.tags.includes('Visitas')) {
            _this.breadcrumb.level_2.title = 'Visitas';
            _this.breadcrumb.level_2.url = '/#/customer_insights/visitor_presentation';
          } else if (response.data && response.data.tags && response.data.tags.includes('Métricas')) {
            _this.breadcrumb.level_2.title = 'Métricas';
            _this.breadcrumb.level_2.url = '/#/customer_insights/metricas/reports';
          } else {
            _this.breadcrumb.level_2.title = 'Insights';
            _this.breadcrumb.level_2.url = '/#/customer_insights/somos1/reports';
          }
        } else if (response.data.section === 'Empresas') {
          _this.breadcrumb.level_1.title = _this.translate('menu.customer.companies');
          _this.breadcrumb.level_1.url = '/#/customer_insights/companies';
          _this.breadcrumb.level_2.title = response.data.organization.name;
          _this.breadcrumb.level_2.url = '/#/customer_insights/companies/reports?company_code=' + response.data.organization.id;
        }
        _this.breadcrumb.level_3.title = response.data.name;
        _this.breadcrumb.level_3.url = '#/customer_insights/somos1/dashboard/' + response.data.document_id;
        _this.dashboardUrl = _this.report.link;
        _this.maintenance = _this.report.maintenance;
      });
    },
    onCopyCode: function onCopyCode() {
      navigator.clipboard.writeText(this.report.code);
      this.$toast.info(this.translate('frases.code_copied'));
      this.showDashboard = true;
      this.send_event();
    },
    send_event: function send_event() {
      console.log(this.$route.params.reg);
    },
    onIframeLoad: function onIframeLoad() {
      var _this2 = this;
      setTimeout(function () {
        _this2.isAnimated = 1;
      }, 4000);
      setTimeout(function () {
        _this2.isAnimated = 0;
      }, 6000);
    }
  },
  computed: {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.breadcrumb.level_1.title,
        disabled: false,
        href: this.breadcrumb.level_1.url
      }, {
        text: this.breadcrumb.level_2.title,
        disabled: false,
        href: this.breadcrumb.level_2.url
      }, {
        text: this.breadcrumb.level_3.title,
        disabled: true,
        href: this.breadcrumb.level_3.url
      }];
    }
  }
};